import React from 'react'
import { compose } from 'recompose'
import { IntlShape, injectIntl } from 'react-intl'
import { withFormik } from 'formik'
import Brief from './Brief/index'
import { redirectUserTo } from '@src/utils/redirectUser'
import { sendBriefAnalytics } from '@src/utils/sendBriefAnalytics'
import { createInitialValueWithUserData } from '@src/utils/prepareFormValues'
import { addRecaptchaDataToken } from '@src/utils/addRecaptchaDataToken'
import { ACCOUNT_ELAMA_GLOBAL } from '@src/constants/AdvertisingBriefs/urls'
import { briefSchema, initialValues } from '@src/constants/AdvertisingBriefs/Social/briefSchema'
import { HTTP_STATUS_REDIRECT } from '@src/constants/api'
import { Formik, FormValues } from '@src/types/BriefSocial/formikProps'
import { UserData } from '@src/types'

interface HOCProps {
  intl: IntlShape
}

interface Props {
  userData: UserData | null
  sendStartFillingBriefAnalytics: () => void
}

const handleSubmit = (values: FormValues, { setSubmitting }) => {
  addRecaptchaDataToken(values)
    .then(() => {
      redirectUserTo(ACCOUNT_ELAMA_GLOBAL)
    })
    .catch(({ response }) => {
      console.error(response)
      const { statusCode, data } = response.data
      const { briefId, redirectUrl } = data

      if (statusCode === HTTP_STATUS_REDIRECT) {
        sendBriefAnalytics(briefId, redirectUrl)
      }

      setSubmitting(false)
    })
}

const formProps = {
  enableReinitialize: true,
  mapPropsToValues: props => createInitialValueWithUserData(props, initialValues),
  validationSchema: props => briefSchema(props.intl.formatMessage),
  handleSubmit
}

const BriefNetwork: React.FC<Props & HOCProps & Formik> = props => {
  return <Brief {...props} />
}

const Social = withFormik<Props & HOCProps, FormValues>(formProps)(BriefNetwork)

export default compose(injectIntl)(Social)
